/* eslint-disable import/prefer-default-export */
export const SPACE_BAR_KEYCODE = 32;
